import Container from "react-bootstrap/esm/Container";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";

/**
 * Column parameter overview when a budget is generated
 * @param {*} props 
 * @returns 
 */
const SummaryLink = (props) => {

  if(props.data == undefined) {
    return <></>
  }

  return (

    <Container className="text-center" style={{fontSize: ".85rem"}}>
    <Row className="mt-2">
      <Col><h6 class="h6"><strong>Link Budget Details</strong></h6></Col>
      <Col><h6 class="h6"><strong>User's inputs</strong></h6></Col>
    </Row>
    <Row className="mt-2">
      <Col>Link's name</Col>
      <Col>{props.linkName}</Col>
    </Row>
    <Row className="mt-2">
      <Col>Site 1</Col>
      <Col>{props.data.pdObj.site1Name}</Col>
    </Row>
    { props.advancedLink ?
    <>
    <Row className="mt-2">
      <Col>Site 1 longitude</Col>
      <Col>{props.data.pdObj.site1LongitudeValue} {props.data.pdObj.site1LongitudeDirection}</Col>
    </Row>
    <Row className="mt-2">
      <Col>Site 1 latitude</Col>
      <Col>{props.data.pdObj.site1LatitudeValue} {props.data.pdObj.site1LatitudeDirection}</Col>
    </Row>
    </>
    : <></> }
    <Row className="mt-2">
      <Col>Site 2</Col>
      <Col>{props.data.pdObj.site2Name}</Col>
    </Row>
    { props.advancedLink ?
    <>
    <Row className="mt-2">
      <Col>Site 2 longitude</Col>
      <Col>{props.data.pdObj.site2LongitudeValue} {props.data.pdObj.site2LongitudeDirection}</Col>
    </Row>
    <Row className="mt-2">
      <Col>Site 2 latitude</Col>
      <Col>{props.data.pdObj.site2LatitudeValue} {props.data.pdObj.site2LatitudeDirection}</Col>
    </Row>
    </>
    : <></> }
    <Row className="mt-2">
      <Col>Path length</Col>
      <Col>{props?.edited_miles ? (props.data.pdObj.pathLength/1.609).toFixed(2) : props.data.pdObj.pathLength} {props?.edited_miles ? "miles" : props.data.pdObj.distanceUnit}</Col>
    </Row>
    <Row className="mt-2">
      <Col>Standard</Col>
      <Col>{props.data.edObj.equipmentStandard}</Col>
    </Row>
    <Row className="mt-2">
      <Col>Propagation methodology</Col>
      <Col>{props.data.coObj.multipathOutageStandard}</Col>
    </Row>
    <Row className="mt-2">
      <Col>Propagation condition</Col>
      <Col>{props.data.coObj.propagationCondition}</Col>
    </Row>
    
    { props.advancedLink ?
    <>
    <Row className="mt-2">
      <Col>Fade factor</Col>
      <Col>{ Number.parseFloat( props.data.coObj?.fadeOccurenceFactorAuto).toExponential(10) }</Col>
    </Row>
    </>
    : <></> }
  
    <Row className="mt-2">
      <Col>Rain outage prediction</Col>
      <Col>{props.data.coObj.rainOutageStandard}</Col>
    </Row>

    <Row className={props.data.coObj.rainOutageStandard == "ITU.R P530" ? "" : "hide-input"}>
      <Col>Rain rate</Col>
      <Col>{props.advancedLink ? props.data.coObj.manualRainRate : props.data.coObj.rainRate} mm/hr</Col>
    </Row>

    <Row className={props.data.coObj.rainOutageStandard == "ITU.R P530" && props.advancedLink ? "" : "hide-input"}>
      <Col>Rain rate standard</Col>
      <Col>{props.data.coObj.rainOutageMethod}</Col>
    </Row>

    <Row className={props.data.coObj.rainOutageStandard == "ITU.R P530" ? "hide-input" : ""}>
      <Col>Crane zone</Col>
      <Col>{props.data.coObj.craneZone}</Col>
    </Row>

    <Row className={props.advancedLink ? "" : "hide-input"}>
      <Col>Annual outage methodology</Col>
      <Col>{props.data.coObj.annualOutageMethod}</Col>
    </Row>

    <Row className={props.advancedLink && props.data.coObj.annualOutageMethod != "itu" ? "" : "hide-input"}>
      <Col>Average temperature</Col>
      <Col>{props.data.coObj.avgTempValue} {props.data.coObj.avgTempUnit}</Col>
    </Row>

    <Row className="mt-2">
      <Col>Field margin</Col>
      <Col>{props.data.coObj.calculationMargin} dB</Col>
    </Row>

    <Row className="mt-2">
      <Col>Equipment</Col>
      <Col>{props.equipmentType}</Col> 
    </Row>

    <Row className="mt-2">
      <Col>Frequency</Col>
      <Col>{props.data.edObj.frequencyBand == 6.2 ? 6 : props.data.edObj.frequencyBand} GHz</Col>
    </Row>

    <Row className="mt-2">
      <Col>Channel bandwidth</Col>
      <Col>{props.data.edObj.channelBandwidth} MHz</Col>
    </Row>

    <Row className="mt-2">
      <Col>Configuration</Col>
      <Col>{props.data.edObj.linkConfiguration.match(/[0-9]\+[0-9]/)[0]}</Col>
    </Row>

    {props.data.edObj.linkConfiguration.includes("1+1") || props.data.edObj.linkConfiguration.includes("2+2") || props.data.edObj.linkConfiguration.includes("4+4") ? 
    <>
    <Row className="mt-2">
      <Col>Space diversity</Col>
      <Col>{props.data.edObj.linkConfiguration.includes("SD") ? "ON" : "OFF"}</Col>
    </Row>
    </>
    :
    <></>
    }

    <Row className="mt-2">
      <Col>Polarization</Col>
      <Col>{props.data.edObj.linkConfiguration.includes("AP") ? "Alternate polar" : "Copolar"}</Col>
    </Row>

    {props.data.edObj.linkConfiguration.includes("AP") ?
    <>
    <Row className="mt-2">
      <Col>XPIC</Col>
      <Col>{props.data.edObj.linkConfiguration.includes("XPIC") ? "ON" : "OFF"}</Col>
    </Row>
    </> : <></> }
    
    <Row className="mt-2">
      <Col>Orientation</Col>
      <Col>{props.data.edObj.linkPolarization == "H" ? "Horizontal" : "Vertical"}</Col>
    </Row>

    <Row className="mt-2">
      <Col>Adaptative modulation</Col>
      <Col>{props.data.edObj.adaptiveModulation ? "ON" : "OFF"}</Col>
    </Row>

    {props.data.edObj.adaptiveModulation ? 
    <>
      <Row className="mt-2">
        <Col>Minimum modulation</Col>
        <Col>{props.data.edObj.minModulation}</Col>
      </Row>
      <Row className="mt-2">
        <Col>Maximum modulation</Col>
        <Col>{props.data.edObj.maxModulation}</Col>
      </Row>
    </>
    : 
    <>
      <Row className="mt-2">
        <Col>Modulation</Col>
        <Col>{props.data.edObj.minModulation}</Col>
      </Row>
    </>
    }

    <Row className="mt-2">
      <Col>TX Power</Col>
      <Col>{props.data.edObj.txPowers[0]} dBm</Col>
    </Row>

    <Row className="mt-2">
      <Col>{props.data.edObj.linkConfiguration.includes("SD") ? "Site 1 main antenna" : "Site 1 antenna"}</Col>
      <Col>{props.data.adObj.site1AntennaMain}</Col>
    </Row>

    {props.data.edObj.linkConfiguration.includes("SD") ?
    <>
    <Row className="mt-2">
      <Col>Site 1 diversity antenna</Col>
      <Col>{props.data.adObj.site1AntennaDiv}</Col>
    </Row>
    </>
    : <></>}
    
    <Row className="mt-2">
    <Col>{props.data.edObj.linkConfiguration.includes("SD") ? "Site 2 main antenna" : "Site 2 antenna"}</Col>
      <Col>{props.data.adObj.site2AntennaMain}</Col>
    </Row>

    {props.data.edObj.linkConfiguration.includes("SD") ?
    <>
      <Row className="mt-2">
        <Col>Site 2 diversity antenna</Col>
        <Col>{props.data.adObj.site2AntennaDiv}</Col>
    </Row>
    </>
    : <></>}

    <Row className="mt-2">
      <Col>Site 1 additional line loss</Col>
      <Col>{props.data.clObj.site1LineMain} dB</Col>
    </Row>
    <Row className="mt-2">
      <Col>Site 2 additional line loss</Col>
      <Col>{props.data.clObj.site2LineMain} dB</Col>
    </Row>
    </Container>

  );

};

export default SummaryLink;